<template>
  <div class="component">
    <div class="row justify-content-center">
      <div class="col col-md-6 col-lg-4">
        <div class="tab">
          <router-link :to="{ name: 'Points' }" class="item" :class="{ 'is-active': $route.name === 'Points' }">
            <div class="content content--count" ref="point">
              <span ref="pointCount">{{ points || 0 | properNumber }}</span>
            </div>
            <div class="label" v-if="!mulitPoint">
              {{ $tc('tab.points', points || 0) }}
            </div>
            <div class="label" v-else>
              {{ $t('tab.programs') }}
            </div>
          </router-link>
          <router-link :to="{ name: 'Coupons' }" class="item" :class="{ 'is-active': $route.name === 'Coupons' }">
            <div class="content content--count" ref="coupon">
              <span ref="couponCount">{{ coupons | properNumber }}</span>
            </div>
            <div class="label">
              {{ $tc('tab.coupons', coupons || 0) }}
            </div>
          </router-link>
          <router-link :to="{ name: 'BrandNews' }" class="item" :class="{ 'is-active': $route.name === 'BrandNews' }">
            <div class="content">
              <i class="material-icons icon">new_releases</i>
            </div>
            <div class="label">
              {{ $t('tab.news') }}
            </div>
          </router-link>
          <router-link :to="{ name: 'Index' }" class="item" exact :class="{ 'is-active': $route.name === 'Index' }">
            <div class="content">
              <i class="material-icons icon">store</i>
            </div>
            <div class="label">
              {{ $t('tab.about') }}
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    avatar: {
      type: String,
    },
    brand: {
      type: String,
      required: true,
    },
    coupons: {
      type: Number,
      required: true,
    },
    points: {
      type: Number,
      required: true,
    },
    mulitPoint: {
      type: Boolean,
      required: true,
    },
  },
  name: 'Tab',
  updated() {
    if (this.$refs.pointCount) {
      // 點數數字動態字級
      const properPointFontSize =
        Math.min(100 * (4.5 / this.$refs.pointCount.innerText.length), 100);
      if (properPointFontSize < 100) {
        this.$refs.pointCount.style.fontSize = `${properPointFontSize}%`;
      }

      // 禮物券數字動態字級
      const properCouponFontSize =
        Math.min(100 * (4.5 / this.$refs.couponCount.innerText.length), 100);
      if (properCouponFontSize < 100) {
        this.$refs.couponCount.style.fontSize = `${properCouponFontSize}%`;
      }
    }
  },
};
</script>

<style lang="sass" scoped>
.component
  padding: 0 10px

  text-align: center

  &.is-fixed
    z-index: 1020

.tab
  display: flex
  min-height: 78px

.item
  position: relative
  width: 25%
  padding: 10px 0

  color: #8E8E8E

  &:active
    opacity: .25

  &.is-active
    font-weight: bold

    .content--count,
    .label,
    .content
      color: white

    &::after
      position: absolute
      top: auto
      right: 15px
      bottom: 0
      left: 15px
      height: 4px

      border-radius: 4px 4px 0 0

      background-color: #ffea00

      content: ''

.content
  height: 32px
  display: block

  margin-bottom: 8px
  line-height: 32px

  &--count
    height: 32px
    overflow: hidden
    max-width: 100%
    padding-top: 2px

    font-size: 30px
    line-height: 30px
    font-weight: 300
    color: rgba(255, 255, 255, .75)

    text-overflow: ellipsis
    white-space: nowrap

  img
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .25)
    width: 32px
    height: auto

    border: 1px solid white
    border-radius: 2px

    &.round
      border-radius: 50%

  .icon
    margin: 5px 0;

.label
  font-size: 0.75rem

  [lang=en] &
    font-size: 0.875rem
</style>
